var _filter, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppropriatenessAssessmentQuestionNine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "brightness"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0.65
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "linear",
    slope: 0.65
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "linear",
    slope: 0.65
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.594 83C64.5658 83 83.1881 64.4198 83.1881 41.5C83.1881 18.5802 64.5658 0 41.594 0C18.6223 0 0 18.5802 0 41.5C0 64.4198 18.6223 83 41.594 83Z",
    fill: "#242D33"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2025_3594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4414 59.332H65.7773V67.3887H46.4414V59.332Z",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1094 59.332H65.7773V67.3887H56.1094V59.332Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8617 39.4591L38.3842 45.9044L32.8818 46.8471L33.8406 41.3604L40.2859 34.8828C41.3811 35.4951 42.2835 36.1396 42.9602 36.7843C43.6049 37.3965 44.2496 38.2987 44.8617 39.4591Z",
    fill: "#415360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3843 45.9044L44.8618 39.4591C44.2497 38.2989 43.605 37.3967 42.9601 36.7844L32.9004 46.8441L38.3843 45.9044Z",
    fill: "#333F48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7508 33.078L56.2703 43.0039L46.0867 46.7421L45.9577 46.3553C45.8103 46.0316 44.0224 39.9982 41.833 37.9442C39.7695 35.8815 33.7446 33.7871 33.3892 33.7871L33.0029 33.6581L36.8105 23.668L46.7957 20.3807C47.2792 22.0566 48.9873 26.8583 50.9208 28.8241C52.8865 30.7578 57.6883 32.4657 59.364 32.9492L59.7508 33.078Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    filter: "url(#brightness)",
    d: "M41.8326 37.9443C44.0222 39.9982 45.8098 46.0317 45.9573 46.3555L46.0863 46.7422L56.27 43.0039L59.7504 33.078L59.3636 32.9492C57.6878 32.4657 52.8861 30.7578 50.9203 28.8241L41.8145 37.9297C41.8196 37.9347 41.8279 37.9394 41.8326 37.9443Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0088 61.2528L33.8628 41.3707L38.4124 45.914L18.5585 65.796L14.0088 61.2528Z",
    fill: "#415360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.796 20.3808L33.0033 33.6581L27.0088 27.6641L40.6729 14L46.6673 19.9941L46.796 20.3808Z",
    fill: "#596C76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2188 65.7773V69H69V65.7773H43.2188Z",
    fill: "#465A61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0801 46.743L59.7421 33.081L65.7354 39.0743L52.0734 52.7363L46.0801 46.743Z",
    fill: "#465A61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2832 63.5247L36.1371 43.6427L38.412 45.9144L18.5581 65.7964L16.2832 63.5247Z",
    fill: "#333F48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1094 65.7773H69V69H56.1094V65.7773Z",
    fill: "#2E3A40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2025_3594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppropriatenessAssessmentQuestionNine);
export default __webpack_public_path__ + "static/media/AppropriatenessAssessmentQuestionNine.151ca4b37b8fdb34001d223ea045ed28.svg";
export { ForwardRef as ReactComponent };